// components/ConfirmModal.tsx
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"

type ConfirmModalProps = {
    open: boolean
    onConfirm: () => void
    onCancel: () => void
    title?: string
    message?: string
}

export const ConfirmModal = ({ open, onConfirm, onCancel, title, message }: ConfirmModalProps) => {
    return (
        <Dialog open={open} onOpenChange={onCancel}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{title ?? "Are you sure?"}</DialogTitle>
                </DialogHeader>
                <p className="text-sm text-gray-500 dark:text-gray-400">{message ?? "This action cannot be undone."}</p>
                <DialogFooter className="mt-4 flex justify-end gap-2">
                    <Button variant="ghost" onClick={onCancel}>Cancel</Button>
                    <Button onClick={onConfirm} className="bg-red-600 hover:bg-red-700 text-white">
                        Yes, Leave Clan
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
